"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SzCard = void 0;

var react_1 = __importStar(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var styled_components_1 = __importDefault(require("styled-components"));

var SzTypographie_1 = require("../SzTypographie/SzTypographie");

var react_spring_1 = require("react-spring");

var CardContext = react_1.default.createContext({});

var Container = function Container(props) {
  var cardContext = react_1.useContext(CardContext);

  if (cardContext.background && !cardContext.children) {
    var hoverProps = {
      onMouseEnter: function onMouseEnter() {
        var _a;

        return (_a = cardContext.setIsHover) === null || _a === void 0 ? void 0 : _a.call(cardContext, true);
      },
      onMouseLeave: function onMouseLeave() {
        var _a;

        return (_a = cardContext.setIsHover) === null || _a === void 0 ? void 0 : _a.call(cardContext, false);
      }
    };
    return react_1.default.createElement(react_spring_1.animated.div, __assign({}, hoverProps, {
      className: cardContext.cardClasses,
      style: {
        boxShadow: cardContext.boxShadow
      }
    }), props.children);
  }

  return react_1.default.createElement("div", {
    className: cardContext.cardClasses
  }, props.children);
};

var CardWrapper = function CardWrapper(_a) {
  var _b;

  var className = _a.className,
      title = _a.title,
      titleProps = _a.titleProps,
      color = _a.color,
      children = _a.children,
      background = _a.background,
      imgProps = _a.imgProps,
      padding = _a.padding;

  var _c = __read(react_1.useState(false), 2),
      isHover = _c[0],
      setIsHover = _c[1];

  var cardClasses = classnames_1.default('sz-card rounded-lg', className);
  var contentClasses = classnames_1.default('sz-card-content', {
    'p-3': !background || padding === 'normal',
    'p-4': padding === 'large'
  });
  var headerClasses = classnames_1.default('m-0', (_b = {}, _b["bg-" + color + "-light"] = color, _b['p-3'] = !background || background && !children || padding === 'normal', _b['p-4'] = padding === 'large', _b['pt-3 pb-1 px-2'] = background && children, _b));

  var _d = __read(react_spring_1.useSpring(function () {
    return {
      from: {
        boxShadow: '0px 0px 4px 2px #0000000D',
        transform: 'scale(1)'
      },
      to: {
        boxShadow: '0px 0px 32px 16px #0000000D',
        transform: 'scale(1.1)'
      },
      reverse: !isHover
    };
  }, [isHover]), 1),
      _e = _d[0],
      boxShadow = _e.boxShadow,
      transform = _e.transform;

  var Image = function Image() {
    if (background && !children) {
      return react_1.default.createElement(react_spring_1.animated.img, __assign({
        style: {
          transform: transform
        },
        src: background,
        className: "sz-card-background-img w-100",
        alt: ""
      }, imgProps));
    }

    return react_1.default.createElement("img", __assign({
      src: background,
      className: "sz-card-background-img w-100",
      alt: ""
    }, imgProps));
  };

  return react_1.default.createElement(CardContext.Provider, {
    value: {
      background: background,
      boxShadow: boxShadow,
      cardClasses: cardClasses,
      children: children,
      setIsHover: setIsHover
    }
  }, react_1.default.createElement(Container, null, background && react_1.default.createElement("div", {
    className: "sz-card-background-container sz-rounded-top overflow-hidden"
  }, react_1.default.createElement(Image, null)), title && react_1.default.createElement(SzTypographie_1.SzTypographie, __assign({
    className: headerClasses,
    align: "center",
    variant: "h2",
    weight: "bold",
    tag: "div"
  }, titleProps), title), children && react_1.default.createElement("div", {
    className: contentClasses
  }, children)));
};

exports.SzCard = styled_components_1.default(CardWrapper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var direction = _a.direction,
      color = _a.color;
  return direction && "border-" + direction + ": solid 4px var(--" + color + ");";
});
exports.default = exports.SzCard;
var templateObject_1;